
// Responds to TRIGGER_EDAP_EVENT action
function triggerEdapEvent(store, action = {payload: {eventName: '', eventData: {}, options: {}}}) {
    if (typeof window === 'undefined') {
        return;
    }

    const {payload} = action;
    const newEventData = {
        eventcategory: 'Scratchpad',
        ...payload.eventData
    };

    window.edap.push((edapInstance) => {
        edapInstance.trigger(payload.eventName, newEventData, payload.options);
    });
}

// responds to TRIGGER_EDAP_PAGEVIEW action
function triggerEdapPageView() {
    if (typeof window === 'undefined') {
        return;
    }

    window.edap.push((edapInstance) => {
        edapInstance.trigger('pageview');
    });
}

export {triggerEdapPageView, triggerEdapEvent};



// WEBPACK FOOTER //
// ./src/universal/middleware/edap.js